import type { ReactElement } from 'react';

import { Checkbox, type CheckboxProps } from '@frontend/components';

import type { TimeUnitPlural } from './types';

const DATE_UNIT_PLURAL_TO_INCLUSION_LABEL_MAP: Record<
  TimeUnitPlural,
  ReactElement
> = {
  hours: (
    <>
      Include this <b>hour</b>
    </>
  ),
  days: (
    <>
      Include <b>today</b>
    </>
  ),
  weeks: (
    <>
      Include this <b>week</b>
    </>
  ),
  months: (
    <>
      Include this <b>month</b>
    </>
  ),
};

export type IsInclusiveCheckboxProps = CheckboxProps & {
  unit: TimeUnitPlural;
};

const IsInclusiveCheckbox = ({
  name,
  unit,
  ...rest
}: IsInclusiveCheckboxProps) => {
  return (
    <Checkbox name={`${name}_isInclusive`} {...rest}>
      {DATE_UNIT_PLURAL_TO_INCLUSION_LABEL_MAP[unit]}
    </Checkbox>
  );
};

export default IsInclusiveCheckbox;
